<template>
  <div class="main">
    <!--    上部-->
    <div class="top">
      <div class="left-top">
        <div class="left-top-nav clearfix">
          <p class="">订单采购</p>
          <ul class="right">
            <li>·</li>
            <li>·</li>
            <li>·</li>
          </ul>
        </div>
        <!--  下面-->
        <div class="left-top-main">
          <!-- 环形图-->
          <div class="top-main-left">
            <div id="pie1" class="pie"/>
            <p class="amounts">累计金额</p>
            <p class="wy">(万元)</p>
            <span>近7日新增(万元)<i>0</i></span>
          </div>
          <!--表格-->
          <div class="top-main-right">
            <p class="total right">(金额：万元 | 累计订单：笔)</p>
            <div class="table right">
              <el-table
                :data="buyOrder"
                border
                style="width: 100%">
                <el-table-column
                  prop=""
                  label=""
                  width="36">
                  <template slot-scope="scope">
                    <!--{{scope.$index + 1}}-->
                    <div id="sign" :class="'sign' + scope.$index"/>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="prefecture"
                  label="专区"
                  width=""
                />
                <el-table-column
                  prop="moneyTotal"
                  label="累计金额"/>
                <el-table-column
                  prop="newly"
                  label="近七日新增"/>
                <el-table-column
                  prop="orderTotal"
                  label="累计订单"/>
                <el-table-column
                  prop="newPro"
                  label="近七日新增"/>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!--  右上侧待办区-->
      <div class="right-top">
        <div class="right-top-nav clearfix">
          <p class="mine left">我的待办(30)</p>
          <a class="more right" @click.prevent="waitHandle">更多>></a>
        </div>
        <el-table
          :data="myBackog"
          style="width: 100%">
          <el-table-column
            prop="num"
            label="序号"
            width="48"/>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="message"
            label="申请"
            width="244"/>
          <el-table-column
            prop="state"
            label="状态"
            width="50"
          />
        </el-table>
      </div>
    </div>
    <!--    下部-->
    <div class="bottom">
      <div class="left-bottom ">
        <div class="left-bottom-nav clearfix">
          <p class="left">招标采购</p>
          <ul class="right">
            <li>·</li>
            <li>·</li>
            <li>·</li>
          </ul>
        </div>
        <!--  下面 -->
        <div class="left-bottom-main clearfix">
          <!-- 环形图-->
          <div class="bottom-main-left">
            <div id="pie2" class="pie"/>
            <p class="amount">累计金额</p>
            <p class="yy">(亿元)</p>
            <span>近7日新增(亿元)<i>0</i></span>
          </div>
          <!--  表格  -->
          <div class="bottom-main-right">
            <p class="total right">(金额：亿元 | 定标数量：笔)</p>
            <div class="table right">
              <el-table
                :data="openTender"
                border
                style="width: 100%">
                <el-table-column
                  prop=""
                  label=""
                  width="36">
                  <template slot-scope="scope">
                    <!-- {{scope.$index}}-->
                    <div id="sign" :class="'sign' + scope.$index"/>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="procurement"
                  label="采购方式"
                  width=""
                />
                <el-table-column
                  prop="proMoney"
                  label="预计采购额"/>
                <el-table-column
                  prop="newMoney"
                  label="新增额"/>
                <el-table-column
                  prop="newly1"
                  label="近七日新增"/>
                <el-table-column
                  prop="number"
                  label="定标数量"/>
                <el-table-column
                  prop="newly2"
                  label="近七日新增"/>
              </el-table>
            </div>
          </div>
        </div>
      </div>
      <!--   右下消息  -->
      <div class="right-bottom">
        <div class="right-top-nav clearfix">
          <p class="mine left message">消息提醒(99+)</p>
          <a href="#" class="more right">更多>></a>
        </div>
        <el-table
          :data="myMessage"
          style="width: 100%">
          <el-table-column
            prop="num"
            label="序号"
            width="48"/>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="message"
            label="消息"
            width="244"/>
          <el-table-column
            prop="state"
            width="50"
            label="状态"/>
        </el-table>
      </div>
    </div>
    <!--  底部--layout组件中el-simple-footer-->
    <el-simple-footer></el-simple-footer>
  </div>
</template>
<script>
import MyEcharts from 'echarts'

export default {
  name: 'Dashboard',
  data () {
    return {
      myBackog: [{
        num: '01',
        message: '刘欣合同申请',
        state: '待审批'
      }, {
        num: '02',
        message: '宋运辉合同申请',
        state: '待审批'
      }, {
        num: '03',
        message: '王铭合同申请',
        state: '待审批'
      }, {
        num: '04',
        message: '郑凯合同申请',
        state: '待审批'
      }, {
        num: '05',
        message: '宋运辉合同申请',
        state: '待审批'
      }, {
        num: '06',
        message: '王铭合同申请',
        state: '待审批'
      }],
      myMessage: [{
        num: '01',
        message: '账单确认提醒：2019-03期账单需您确认订单',
        state: '未读'
      }, {
        num: '02',
        message: '付款提醒：2019-03期账单离付款截止日期还有2天',
        state: '未读'
      }, {
        num: '03',
        message: '账单确认提醒：2019-02期账单需您确认账单',
        state: '未读'
      }, {
        num: '04',
        message: '付款提醒：2019-02期账单离付款截止日期还有2天',
        state: '未读'
      }, {
        num: '05',
        message: '账单确认提醒：2019-01期账单需您确认账单',
        state: '未读'
      }, {
        num: '06',
        message: '付款提醒：2019-01期账单离付款截止日期还有2天',
        state: '未读'
      }],
      buyOrder: [{
        prefecture: '差旅专区',
        moneyTotal: '7761.91',
        newly: '0',
        orderTotal: '76030',
        newPro: '0'
      }, {
        prefecture: '询价专区',
        moneyTotal: '8129.73',
        newly: '0',
        orderTotal: '992',
        newPro: '0'
      }, {
        prefecture: '工程专区',
        moneyTotal: '798.36',
        newly: '0',
        orderTotal: '911',
        newPro: '0'
      }, {
        prefecture: '电子超市',
        moneyTotal: '734.03',
        newly: '0',
        orderTotal: '4112',
        newPro: '0'
      }],
      openTender: [{
        procurement: '公开招标',
        proMoney: '2812.69',
        newMoney: '2203.37',
        newly1: '0',
        number: '76030',
        newly2: '0'
      }, {
        procurement: '邀标',
        proMoney: '1324.82',
        newMoney: '1135.94',
        newly1: '0',
        number: '992',
        newly2: '0'
      }, {
        procurement: '竞争谈判',
        proMoney: '100.48',
        newMoney: '83.09',
        newly1: '0',
        number: '911',
        newly2: '0'
      }, {
        procurement: '询价',
        proMoney: '171.37',
        newMoney: '147.19',
        newly1: '0',
        number: '4112',
        newly2: '0'
      }, {
        procurement: '其他',
        proMoney: '606.77',
        newMoney: '549.05',
        newly1: '0',
        number: '4112',
        newly2: '0'
      }]
    }
  },
  activated () {
    this.$store.dispatch('showFooter')
  },
  mounted () {
    setTimeout(() => {

    }, 0)
    this.initEcharts1()
    this.initEcharts2()
  },
  methods: {
    waitHandle () {
      console.log('跳转1929999')
      // this.$router.push({ path: 'http://tmpl.iccec.cn/app/approval/#/dashboard'})
      window.location.href = 'http://localhost/app/approval/#/dashboard'
    },
    // 饼图1
    initEcharts1 () {
      const myChart = MyEcharts.init(document.getElementById('pie1'))
      const option = {
        center: ['20%', '20%'],
        tooltip: {
          trigger: 'item',
          formatter: '{c}({d}%)'
        },
        // 饼图中间文字
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '17424.03',
            textAlign: 'center',
            font: '900 25px Arial-Black',
            fill: '#4A4A4A',
            width: 126,
            height: 36
          }
        },
        series: [
          {
            name: '总金额',
            type: 'pie',
            radius: ['82%', '100%'],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            color: [
              '#5576CF', '#2B821D', '#0298D9', '#FFB54A'
            ],
            data: [
              { value: 7761.91, name: '差旅专区' },
              { value: 734.03, name: '电子超市' },
              { value: 798.36, name: '工程专区' },
              { value: 8129.73, name: '询价专区' }
            ]
          }
        ]
      }

      myChart.setOption(option)
    },
    // 饼图2
    initEcharts2 () {
      const myChart = MyEcharts.init(document.getElementById('pie2'))
      const option = {
        center: ['20%', '20%'],
        tooltip: {
          trigger: 'item',
          formatter: '{c}({d}%)'
        },
        // 饼图中间文字
        graphic: {
          type: 'text',
          left: 'center',
          top: 'center',
          style: {
            text: '4118.65',
            textAlign: 'center',
            font: '900 25px Arial-Black',
            fill: '#4A4A4A',
            width: 126,
            height: 36
          }
        },
        series: [
          {
            name: '总金额',
            type: 'pie',
            radius: ['82%', '100%'],
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: 'center'
              },
              emphasis: {
                show: false,
                textStyle: {
                  fontSize: '14',
                  fontWeight: 'bold'
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            color: [
              '#5576CF', '#BD564D', '#2B821D', '#0298D9', '#FFB54A'
            ],
            data: [
              { value: 2812.69, name: '公开招标' },
              { value: 171.37, name: '询价' },
              { value: 100.48, name: '竞争谈判' },
              { value: 171.37, name: '其他' },
              { value: 1324.82, name: '邀标' }
            ]
          }
        ]
      }

      myChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/styles/variables";

  .main {
    width: 100%;
    min-width: 1280px;
    height: 100%;
  }

  ul, div, p {
    padding: 0;
    margin: 0;
  }

  .top, .bottom {
    position: relative;
    height: 100%;
  }

  .left-top, .left-bottom {
    height: 311px;
    /*background-color: #fff;*/
    background-color: $--color-white;
    box-sizing: border-box;
    margin-right: 400px;
  }

  /*左上*/
  .left-top {
    position: relative;
    padding: 20px;

    .left-top-nav {
      position: relative;
      width: 100%;

      ul {
        position: absolute;
        top: -14px;
        right: 0;
      }

      li {
        list-style: none;
        height: 6px;
        font-size: 27px;
        /*color: #D8D8D8;*/
        color: $--color-table-zebra;
      }

      p {
        width: 56px;
        height: 23px;
        font-size: 14px;
        font-weight: 600;
        color: $--color-assist-text-1;
        border-bottom: 2px solid $--color-assist-text-1;
        margin-bottom: 10px;
      }
    }

    span {
      position: absolute;
      height: 18px;
      font-size: 13px;
      color: $--breadcrumb-separator-color;
      line-height: 18px;
      margin: 21px 0px 0px 30px;
    }
  }

  i {
    margin-left: 20px;
    font-size: 14px;
    color: $--color-text-primary;
    font-weight: 900;
    font-style: normal;
  }

  /*饼图*/
  .pie {
    width: 160px;
    height: 160px;
    margin: 10px 0 0 30px;
  }

  .left-top-main {
    position: relative;
    height: 100%;

    .top-main-left {
      position: absolute;
      width: 210px;
      margin-right: 43px;

      p {
        font-size: 16px;
        font-weight: 400;
        color: $--breadcrumb-separator-color;
      }

      .amounts {
        position: absolute;
        top: 48px;
        left: 80px;
      }

      .wy {
        position: absolute;
        top: 106px;
        left: 88px;
      }
    }

    .top-main-right {
      margin-left: 253px;
      height: 100%;
    }
  }

  .total {
    width: 152px;
    height: 17px;
    font-size: 12px;
    font-weight: 400;
    color: $--breadcrumb-separator-color;
    line-height: 17px;
    margin-bottom: 5px;
  }

  .table {
    width: 100%;
    height: 180px;
  }

  /*覆盖el-table样式*/
  /*.el-table th>.cell*/
  .el-table {
    font-size: 13px;
    color: $--color-text-primary;

    /deep/ td {
      padding: 6px 0;
    }

    /deep/ th {
      padding: 6px 0;
    }

    /deep/ th > .cell {
      color: $--color-text-primary;
      font-weight: 400;
    }
  }

  /*下面*/
  .bottom {
    margin: 20px 0;
  }

  /*左下*/
  .left-bottom {
    position: relative;
    padding: 20px;

    .left-bottom-nav {
      width: 100%;
      position: relative;
    }

    p {
      width: 56px;
      height: 23px;
      font-size: 14px;
      font-weight: 600;
      color: $--color-assist-text-1;
      border-bottom: 2px solid $--color-assist-text-1;
      margin-bottom: 10px;
    }

    ul {
      position: absolute;
      top: -14px;
      right: 0px;
    }

    li {
      list-style: none;
      height: 6px;
      font-size: 27px;
      color: $--color-table-zebra;
    }

    span {
      display: inline-block;
      height: 18px;
      font-size: 13px;
      color: $--breadcrumb-separator-color;
      margin: 21px 0px 0px 30px;
    }
  }

  /*左下框自适应*/
  .left-bottom-main {
    position: relative;
    height: 100%;

    .bottom-main-left {
      position: absolute;
      width: 210px;
      margin-right: 43px;

      p {
        width: 100%;
        border: none;
        font-size: 16px;
        font-weight: 400;
        color: $--breadcrumb-separator-color;
        line-height: 22px;
      }

      .amount {
        position: absolute;
        top: 48px;
        left: 80px;
      }

      .yy {
        position: absolute;
        top: 106px;
        left: 88px;
      }
    }

    .bottom-main-right {
      margin-left: 253px;

      .total {
        width: 152px;
        height: 17px;
        font-size: 12px;
        font-weight: 400;
        color: $--breadcrumb-separator-color;
        border: none;
        margin-bottom: 5px;
      }
    }
  }

  .right-top, .right-bottom {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 380px;
    height: 312px;
    background-color: $--color-white;
    box-sizing: border-box;
    padding: 20px;

    .el-table {
      margin-top: 8px;

      /deep/ tbody tr {
        cursor: pointer;
      }

      /deep/ .el-table__header-wrapper {
        .el-table_2_column_7, .el-table_4_column_17 {
          .cell {
            padding-left: 8px;
          }
        }
      }

      /deep/ .el-table__row {
        .el-table_4_column_19, .el-table_2_column_9 {
          color: $--color-text-button;
        }
      }

      /deep/ .cell {
        padding-left: 0px;
      }

      /deep/ .el-table__body tr td .cell {
        padding-left: 0px;
      }

      /deep/ .el-table__row td {
        border-bottom: 1px solid transparent;
      }

      /deep/ .el-table__row td:first-child {
        padding-left: 8px;
      }

      /deep/ th.is-leaf {
        border-bottom: 1px solid transparent;
      }

      /deep/ .el-table_3_column_15 {
        padding-left: 0px;
      }
    }

    /deep/ .el-table::before {
      height: 0px;
    }

    /deep/ .el-table th div {
      padding-right: 0px;
    }

    /*右上导航*/
    .right-top-nav {
      width: 100%;

      .mine {
        font-size: 14px;
        width: 85px;
        height: 23px;
        border-bottom: 2px solid $--color-assist-text-1;
        font-weight: 600;
        color: $--color-assist-text-1;
      }

      .more {
        display: block;
        width: 47px;
        height: 18px;
        font-size: 13px;
        font-weight: 400;
        color: $--color-assist-text-1;
        line-height: 18px;
      }
    }
  }

  /*右下列表*/
  .right-bottom {
    .right-top-nav {
      .message {
        width: 95px;
      }
    }
  }

  /*圆点*/
  #sign {
    margin-top: 10px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  .sign0 {
    background-color: $--color-circleBg-0;
  }

  .sign1 {
    background-color: $--color-circleBg-1;
  }

  .sign2 {
    background-color: $--color-circleBg-2;
  }

  .sign3 {
    background-color: $--color-circleBg-3;
  }

  .sign4 {
    background-color: $--color-circleBg-4;
  }

  /*底部*/
  .footer {
    height: 322px;
    /*background-color: #EAEAEA;*/
    margin: 0 -50px;
  }

  .footer-top {
    /deep/ i {
      margin-left: 0px;
      font-weight: 500
    }

    display: flex;
    display: -webkit-box;
    width: 100%;
    height: 80px;
    border-bottom: 1px solid $--color-table-zebra;
    padding: 21px 50px 0 50px;
    justify-content: space-between;

    div {
      height: 42px;
      width: 142px;
      font-size: 20px;
      font-weight: 600;
      color: $--color-culture;

      i {
        font-size: 42px;
        color: $--color-primary;
        margin-right: 20px;
        vertical-align: middle
      }
    }
  }

  .footer-mid {
    display: flex;
    width: 100%;
    height: 183px;
    border-bottom: 1px solid $--color-table-zebra;

    dl, dt, dd {
      margin: 0;
      padding: 0;
    }

    .about {
      flex: 1;
      width: 100%;
      height: 100%;
      margin-left: 50px;

      dl {
        width: 16.6%;
      }

      dl:first-child {
        margin-left: 0px;
      }

      dt {
        height: 20px;
        font-size: 14px;
        font-weight: 600;
        color: $--color-assist-topbar-font;
        line-height: 20px;
        margin: 30px 0px 15px 0px;
      }

      dd {
        height: 17px;
        font-size: 12px;
        font-weight: 500;
        color: $--color-assist-topbar-font;
        line-height: 17px;
        margin-bottom: 10px;
      }
    }

    .code {
      width: 100px;
      height: 100px;
      margin: 30px 50px 0px 0px;
      text-align: center;

      p {
        font-size: 12px;
        font-weight: 500;
        color: $--color-assist-topbar-font;
        margin-top: 10px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .footer-bottom {
    width: 100%;

    .foo {
      width: 524px;
      height: 17px;
      margin: 20px auto;
      line-height: 17px;

      p, span {
        font-size: 12px;
        font-weight: 500;
        color: $--color-assist-topbar-font;
      }

      span {
        margin: 0 9px;
      }
    }
  }

  /*浮动*/
  .left {
    float: left;
  }

  .right {
    float: right;
  }

  /*清除浮动*/
  .clearfix:after {
    display: block;
    clear: both;
    content: "";
    visibility: hidden;
    height: 0
  }

  .clearfix {
    zoom: 1
  }

</style>
